export default __webpack_public_path__ + "static/media/pagination_right_arrow.27933cef.svg";